import * as React from 'react';
import styles from './index.less';
import { getMicroAppName } from '@/constants';
import { MicroApp } from 'umi';
import { Drawer } from 'antd';

interface FMicroApp_MarkdownEditorDrawer_Props {
  resourceID: string;
  open?: boolean;
  appMode?: 'preview' | 'normal';
  version?: string;

  onChange_Saved?(saved: boolean): void;

  onClose?(): void;
}

function FMicroApp_CartoonEditorDrawer({
                                         resourceID,
                                         open = false,
                                         onChange_Saved,
                                         onClose,
                                         appMode,
                                         version,
                                       }: FMicroApp_MarkdownEditorDrawer_Props) {

  // console.log(resourceID, open, '(I***********************');
  if (!resourceID || !open) {
    return null;
  }

  return (<Drawer
    open={true}
    width={'100%'}
    title={null}
    footer={null}
    closable={false}
    destroyOnClose={true}
    styles={{ body: { padding: 0 } }}
  >
    <MicroApp
      name={getMicroAppName('cartoonEditor')}
      resourceID={resourceID}
      onChange_Saved={(saved: boolean) => {
        onChange_Saved?.(saved);
      }}
      onClose={() => {
        onClose?.();
      }}
      appMode={appMode}
      version={version}
    />
  </Drawer>);
}

export default FMicroApp_CartoonEditorDrawer;
